import { atom } from 'recoil'

export const IsJobDone = atom<boolean>({
  key: 'is-job-done-human-detections',
  default: false,
})
